import React, { Component } from 'react'
import '../../css/style.css';
import 'react-bootstrap/dist/react-bootstrap'
import { NavLink } from "react-router-dom"

import AOS from 'aos'
import 'aos/dist/aos.css'
import Lottie from 'react-lottie'
import * as animationData from '../../components/logo.json'



class Header extends Component {

  constructor(props) {
    super(props)
    this.state = { isStopped: false, isPaused: false }
    this.handleLottieKeyDown = this.handleLottieKeyDown.bind(this)
  }

  componentDidMount() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    AOS.init({
      duration: prefersReducedMotion ? 0 : 500,
      delay: prefersReducedMotion ? 0 : 300
    })
  }

  handleLottieKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.setState({ isPaused: true });
    }
  }

  render() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const defaultOptions = {
      loop: !prefersReducedMotion,
      autoplay: !prefersReducedMotion,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      },
      speed: prefersReducedMotion ? 0 : 1
    }


    return (

      <div className="sticky_outer">
        <div className="sticky_inner">
          <div className="sticky_nav_left">
            <div className="sticky_nav_text" >
              <NavLink exact to="/" className="navigation-link" activeClassName="current">Home</NavLink> |
              <a href="https://drive.google.com/file/d/14i6duOzqWAeRmEcVJ_8hwBZ36I_KLXf4/view" target="_blank" rel="noopener noreferrer" className="navigation-link">Resume</a>
            </div>
          </div>
         
            <div className="sticky_logo" data-aos="fade-down">
              <div className="myLogo">

              <NavLink to="/" className="navigation-link" aria-label="Home">
                <Lottie options={defaultOptions}
                  height={100}
                  width={100}
                  isStopped={this.state.isStopped}
                  isPaused={this.state.isPaused}
                  onClick={() => this.setState({ isPaused: true })}
                  onKeyDown={this.handleLottieKeyDown}
                  role="button"
                  tabIndex={0}
                />
              </NavLink>
              </div>


            </div>
         

          <div className="sticky_nav_right">
            <div className="sticky_nav_text" >
              <NavLink to="/projects" className="navigation-link" activeClassName="current">Projects</NavLink> |
              <NavLink to="/contact" className="navigation-link" activeClassName="current">Contact</NavLink></div>
          </div>

        </div>

      </div>

    )
  }
}

export default Header